import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useForm } from "react-hook-form";
import HelmetMetaData from "./HelmetMetaData/HelmetMetaData";

export default function Login() {
  const { isAuthenticated, userLogin } = useContext(AuthContext);
  const [type, setType] = useState("seeker");
  const history = useHistory();
  const { search } = useLocation();

  const { register, handleSubmit, errors, setValue } = useForm();

  useEffect(() => {
    if (isAuthenticated) {
      history.push("/profile?tab=dashboard");
    }
  }, [isAuthenticated]);

  const submitEmailVerificationForm = (value) => {
    axios.post("/api/email_verification", value).then((resp) => {
      if (resp.data.status == "success") {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-success");
      } else {
        $("#messages").html(resp.data.message);
        $("#messages").addClass("alert alert-danger");
      }
      setTimeout(() => {
        $("#messages").html("");
        $("#messages").removeClass("alert alert-danger");
      }, 4000);
    });
  };

  return (
    <div className="section-full p-t120  p-b60 site-bg-light pattern-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="twm-log-reg-form-wrap">
              <h2 className="wt-title text-center">Email Verification</h2>
              <p>
                Please confirm your email address as it has not been verified.
              </p>
              <form onSubmit={handleSubmit(submitEmailVerificationForm)}>
                {/* <div className="radio_tabs">
                  <ul>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        className="radio_btn"
                        value="seeker"
                        ref={register()}
                      />
                      Candidate
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="type"
                        className="radio_btn"
                        value="employer"
                        ref={register()}
                      />
                      Employer
                    </li>
                  </ul>
                </div> */}
                <p>
                  A verification email has been sent. Please input the code
                  provided in the designated field below.
                </p>
                <div className="" id="twm-login-candidate">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group mb-3">
                        <input
                          name="verification_code"
                          type="text"
                          ref={register({
                            required: "Required",
                          })}
                          placeholder="Verification Code"
                        />
                        {errors.otp && (
                          <div id="otpFeedback" className="text-danger">
                            {errors.otp.message}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="col-lg-12">
                      <div
                        className="form-group mb-3 position-relative"
                        id="login-password-group"
                      >
                        <input
                          name="password"
                          type="password"
                          id="login-password"
                          required=""
                          className={`form-control ${
                            errors.password !== undefined ? "is-invalid" : ""
                          }`}
                          placeholder="Password"
                          ref={register({
                            required: "Password field is required",
                          })}
                        />
                        <div
                          className="showPassword"
                          data-relative="#login-password-group"
                          data-formid="#login-password"
                          data-show="false"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <i className="ri-eye-fill"></i>
                        </div>
                        {errors.password && (
                          <div id="passwordFeedback" className="text-danger">
                            {errors.password.message}
                          </div>
                        )}
                      </div>
                    </div> */}

                    <div className="col-md-12">
                      <button type="submit" className="site-button">
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/login.png" alt="info image" />
            </figure>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
}
